import { createSelector } from 'reselect';
import userSelector, { userId } from './user';

const bookingsSelector = createSelector(
  (state) => state.bookings,
  (bookings) => bookings,
);

export const isFetching = createSelector(bookingsSelector, (bookings) => bookings.isFetching);

export const isPosting = createSelector(bookingsSelector, (bookings) => bookings.isPosting);

export const error = createSelector(bookingsSelector, (bookings) => bookings.error);

export const success = createSelector(bookingsSelector, (bookings) => bookings.success);

export const cottages = createSelector(bookingsSelector, (bookings) => bookings.cottages);

export const cancellationPolicy = createSelector(
  bookingsSelector,
  (bookings) => bookings.cancellationPolicy,
);

export const bookingsData = createSelector(bookingsSelector, (bookings) => bookings.data);

export const KYCLevel = createSelector(
  bookingsSelector,
  (bookings) => bookings.userMangoPayInfo && bookings.userMangoPayInfo.KYCLevel,
);

export const singleBooking = createSelector(bookingsSelector, (bookings) => bookings.singleBooking);

export const hostId = createSelector(singleBooking, (booking) =>
  booking.Host ? booking.Host.id : null,
);

export const isHost = createSelector([hostId, userId], (id, id2) => id === id2);

export const isBookingStrict = createSelector(userSelector, (user) => !!user.data.booking_valid);

export default bookingsSelector;
